import { connect } from 'react-redux';
import Component from './Component';

const stateToProps = (state) => {
  return{
    isSuccessData: state.auth.promise.getUserInfo.isSuccess,
    isRejectedData: state.auth.promise.getUserInfo.isRejected,
    isAuthorized: state.auth.isAuthorized,
    user: state.auth.user,
  }
};

export default connect(stateToProps, null)(Component);


// WEBPACK FOOTER //
// ./src/app/containers/Vendor/index.js